module.exports = __webpack_public_path__ + "static/media/p208tech.8f1ed63c.jpg";